import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CoreFetch, PatientApi } from '../../api';
import { Spinner } from '../base/spinner';
import * as S from './patient-details-redirect.styles';

export interface IPatientDetailsRedirectProps {
    isSupport: boolean;
    accountId?: string;
}

export const PatientDetailsRedirect: React.FC<IPatientDetailsRedirectProps> = (props) => {
    const { isSupport, accountId } = props;
    const { externalId } = useParams<{ externalId: string }>();
    const navigate = useNavigate();
    const [error, setError] = React.useState<string | null>(null);

    React.useEffect(() => {
        const lookupPatient = async () => {
            if (!externalId) {
                setError('Patient external ID is missing');
                return;
            }

            try {
                const filterExternalId = [`EQ:${externalId}`];
                const patientApi = CoreFetch<PatientApi>(PatientApi);
                
                const results = isSupport
                    ? await patientApi.listSupportPatients({ filterExternalId, limit: 1 })
                    : await patientApi.listProviderPatients({ filterExternalId, limit: 1 });

                if (!results || results.length === 0) {
                    setError('Patient record not found');
                    return;
                }

                const patientId = results[0].id;
                if (!patientId) {
                    setError('Patient record not found');
                    return;
                }

                const redirectPath = `/${accountId}/patients/${patientId}/statement`;
                    
                navigate(redirectPath, { replace: true });
            } catch (err) {
                console.error('Failed to lookup patient:', err);
                setError('Failed to load patient details. Please try again.');
            }
        };

        lookupPatient();
    }, [externalId, isSupport, accountId, navigate]);

    if (error) {
        return (
            <S.Container>
                <S.ErrorContainer>
                    <S.ErrorMessage>{error}</S.ErrorMessage>
                </S.ErrorContainer>
            </S.Container>
        );
    }

    return (
        <S.Container>
            <S.LoadingContainer>
                <Spinner size={48} />
            </S.LoadingContainer>
        </S.Container>
    );
};
